module.exports = __webpack_public_path__ + "static/luminous_1-c3c86e39a585c5ced33c94a2f0741c5f.jpg";